import { Component } from 'react';
import MediaQuery from 'react-responsive';
import Ad from 'components/Ad';
import Intro from 'components/Intro';
import { breakpointLargeFrom } from 'config';
import styles from './styles.css';

export default class Hero extends Component {
	render() {
		return (
			<div className={styles.hero}>
				<div className={styles.scroller}>
					<img className={styles.scrollie} src={require('./images/ian-cheng2.gif')}/>
					<img className={styles.scrollie} src={require('./images/parreno.gif')}/>
					<img className={styles.scrollie} src={require('./images/zoom-pavillion.gif')}/>
				</div>

				<div className={styles.wrapper}>
					<Ad tag="ad_bnr_atf_01" className={styles.ad} />

					<div className={styles.title}>
						Decoding the thrilling world of digital art
					</div>

					<MediaQuery minWidth={breakpointLargeFrom}>
						<Intro theme="light" />
					</MediaQuery>
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Hero/index.js
 **/